import Flickity from 'flickity';

const initPlanCompareBlock = (): void => {
    document.querySelectorAll('.tv-plan-compare__carousel').forEach((element: HTMLElement) => {
        const flkty = new Flickity(element, {
            prevNextButtons: true,
            pageDots: true,
            cellAlign: 'left',
            initialIndex: 1,
        })

        const resize = (): void => {
            let max = 0;
            element.querySelectorAll('.carousel-cell').forEach((cell: HTMLElement) => {
                cell.style.removeProperty('height');
                const height = cell.getBoundingClientRect().height;
                if (height > max) {
                    max = height;
                }
            })

            element.querySelectorAll('.carousel-cell, .flickity-viewport').forEach((cell: HTMLElement) => {
                cell.style.height = `${max}px`
            });
        }

        resize();
        // @ts-ignore
        flkty.on('resize', () => resize());

        flkty.on('change', (index) => {
            if (window.innerWidth > 992) { // desktop size only
                const nextButton = element.querySelector('.flickity-prev-next-button.next');
                // @ts-ignore
                if (index > flkty.cells.length - 4) {
                    nextButton.setAttribute('disabled', 'true');
                } else {
                    nextButton.removeAttribute('disabled');
                }
            }
        })
    });

    document.querySelectorAll('.tv-plan-compare').forEach((block: HTMLElement) => {
        block.querySelectorAll('input[name=currency]').forEach((input: HTMLInputElement) => {
            input.addEventListener('change', (e) => {
                // @ts-ignore
                const value = e.target.value;

                block.querySelectorAll('.tv-plan-compare__info-wrap').forEach((plan: HTMLElement) => {
                    const priceData = plan.getAttribute('data-price');
                    const currencyPrice = JSON.parse(priceData)[value];

                    plan.querySelectorAll('.tv-plan-compare__price').forEach((price: HTMLElement) => {
                        if (currencyPrice) {
                            price.innerText = currencyPrice;
                        } else {
                            price.innerHTML = '&nbsp;';
                        }
                    })
                })
            })
        })
    })

}

export default initPlanCompareBlock;
